import {Component, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal/bs-modal-ref.service";

@Component({
    selector: 'app-checklist-referance-modal',
    templateUrl: './checklist-referance-modal.component.html',
    styleUrls: ['./checklist-referance-modal.component.scss']
})
export class ChecklistReferanceModalComponent implements OnInit {

    public documentSystemID: number;

    constructor(public bsModalRef: BsModalRef) {
    }

    ngOnInit() {
    }

    closeModal() {
        this.bsModalRef.hide();
    }

}



// WEBPACK FOOTER //
// /app/src/app/audit-management/checklist-referance-modal/checklist-referance-modal.component.ts